<template>
  <div class="section grid">
    <side-nav :number="selected_button" :sideNavActive="sideNavActive" :type="current_type"></side-nav>
    <div class="section__detail grid">
      <div class="section-grid__col1">
        <ul class="section-grid__col1__legend">
          <template v-for="section in $appData"
                    v-if="section.id === selected_button && section.code === current_code">
            <li class="flex" v-for="legend in section.type[current_type].legend.titles">
              <div class="button-like">{{ legend.number }}</div>
              <div>{{ $appConfig.legend_titles[legend.title] }}</div>
            </li>
          </template>
        </ul>
        <div>
          <template v-for="file_extension in $appConfig.download">
            <a  class="download-button flex" download
               :href="`${$appConfig.path.file}/${file_extension}/${current_code}.${file_extension}`">
              <div>download {{ file_extension }}</div>
              <div><img :src="'img/icon-download.svg'"></div>
            </a>
          </template>
        </div>
      </div>
      <div class="section-grid__row1">
        <router-link to="/home" class="back-button"><img :src="'img/back-arrow@0,5x.svg'"> Back</router-link>
      </div>
      <div class="section-grid__row2">
        <picture>
          <source media="(max-width:736px)"
                  :srcset="`${$appConfig.path.picture}/${current_code}@0,5.jpg`">
          <img :src="`${$appConfig.path.picture}/${current_code}.jpg`">
        </picture>
      </div>
      <div class="section-grid__row3">
        <cartouche :code="current_code" :title="current_title" :type="current_type"></cartouche>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from './SideNav.vue';
import Cartouche from './Cartouche.vue';

export default {
  name: "Section",
  created() {
    if (this.$route.params.number) {
      this.selected_button = this.$route.params.number;
      this.current_code = this.$route.params.code;
      this.current_title = this.$route.params.title;

    } else {
      let obj = this.$appData.find((data) => {
        return data.code === this.$route.params.code
      });
      if (obj) {
        this.selected_button = obj.id;
        this.current_code = obj.code;
        this.current_title = obj.title;
      }
    }
    if (this.$route.params.type) this.current_type = this.$route.params.type;
    if (this.selected_button > 0) {
      this.section_data = this.$appData.find((data) => +data.id === +this.selected_button);
    }
  },
  watch: {
    '$route'(to) {
      if (to.params.code) {
        let obj = this.$appData.find((data) => {
          return data.code === to.params.code
        });
        if (obj) {
          this.current_code = obj.code;
          this.current_title = obj.title;
        }
      }
      if (to.params.type) this.current_type = to.params.type;
    }
  },
  data() {
    return {
      selected_button: 0,
      current_code: '',
      current_type: '',
      current_title: '',
      sideNavActive: true,
      section_data: ''
    }
  },
  components: {SideNav, Cartouche},
  methods: {
    sort_array(array) {
      return array.sort((a, b) => a - b)
    }
  }
}
</script>
